import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, LayoutDashboard } from 'lucide-react';
import Button from '../../components/ui/Button';
import { AppRoutes } from '../../constants/routes';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center p-6">
      <div className="w-20 h-20 rounded-2xl bg-red-50 border border-red-100 flex items-center justify-center text-red-600 mb-6 shadow-sm">
        <ShieldAlert className="w-10 h-10" />
      </div>
      <span className="text-sm font-bold text-red-600 tracking-wider uppercase mb-1">
        Access Denied
      </span>
      <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight mb-2">
        Unauthorized Action
      </h1>
      <p className="text-sm text-slate-500 max-w-md mb-8">
        You do not have the required permissions or society scope access to view this resource. Please contact your system administrator if you believe this is an error.
      </p>

      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          leftIcon={<ArrowLeft className="w-4 h-4" />}
        >
          Go Back
        </Button>
        <Button
          variant="primary"
          onClick={() => navigate(AppRoutes.DASHBOARD)}
          leftIcon={<LayoutDashboard className="w-4 h-4" />}
        >
          Return to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
